module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAaCAYAAACgoey0AAAACXBIWXMAAAsSAAALEgHS3X78AAABPklEQVRIie2WTWqEQBCFu+1WQUU8Qm6g4AVCVllkdnOgOVB2k0VWOYGC3sAjiMwsbC0rVDOKk0QGonEI+Db+v6+q2mqKIyIbK8uyF875ni0oRHyNouht7HgFJigAHG3bZpZlLUJWSrG6rpkQYjeGy6soON8T1HXdxdI1TVMfAYCqOICNry8ulektz2/gtbSBV5NupzzPjwDwLIToENHquo55njf8kb9V0zTsdDoxwzCoYxQAGEKI9zAMdzxJkkfO+Yfv+1wIoRHn81l/FATBLHBZljr4vj0BgFVVhYj4pEvtuu4AvVxThLOrTh7jPYEYxGL9Gv8EWQo8dW9rpw28gf8/WE4+kJK2t3nmctJ+Guw4zizoLd13jWkSXEs9i0pdKKVaOv+LQW8sgl5YhR4E0jR9kFIe1ki6bdtDHMfFJ0TqdLmvBwPoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/seat/seatForbid.png
// module id = aYh/
// module chunks = 1